import React from 'react';
import { Facebook, Twitter, Youtube, Phone, Mail, MapPin, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const Footer = () => {
  const { language } = useLanguage();
  
  const companyInfo = {
    phone: '+243 97 13 27 318',
    email: 'infos@gci-rdc.com',
    address: 'Route de Matadi numéro 44, commune de Ngaliema/Kinshasa - République Démocratique du Congo',
    hours: language === 'fr' ? 'Lundi à Vendredi de 8h00\' — 16h00\'' : 'Monday to Friday from 8:00 AM — 4:00 PM'
  };
  
  const quickLinks = [
    { name: getTranslation(language, 'aboutCompany'), url: '#about' },
    { name: getTranslation(language, 'publications'), url: '/publications' },
    { name: getTranslation(language, 'projects'), url: '/votre-projet' }
  ];

  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1800px] mx-auto px-6 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <div className="w-20 h-20 rounded-full overflow-hidden shadow-lg border-4 border-orange-500">
                <img 
                  src="https://customer-assets.emergentagent.com/job_166b91da-a769-4162-9f6c-f6ec47415337/artifacts/h0jkwlmz_Capture%20d%E2%80%99e%CC%81cran%202026-02-16%20a%CC%80%2020.38.46.png" 
                  alt="Global Construction Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-500 flex items-center justify-center transition-all duration-300 transform hover:scale-110"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#FF8C00' }}>
              {getTranslation(language, 'quickAccess')}
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.url}
                    className="text-gray-400 hover:text-orange-500 transition-colors text-base"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-2xl font-bold mb-6" style={{ color: '#FF8C00' }}>
              {getTranslation(language, 'contactUs')}
            </h3>
            <ul className="space-y-4">
              <li className="flex gap-3 text-gray-400 text-base">
                <MapPin size={20} className="flex-shrink-0 text-orange-500" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex gap-3 text-gray-400 text-base">
                <Phone size={20} className="flex-shrink-0 text-orange-500" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-orange-500 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex gap-3 text-gray-400 text-base">
                <Clock size={20} className="flex-shrink-0 text-orange-500" />
                <span>{companyInfo.hours}</span>
              </li>
              <li className="flex gap-3 text-gray-400 text-base">
                <Mail size={20} className="flex-shrink-0 text-orange-500" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-orange-500 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800">
        <div className="max-w-[1800px] mx-auto px-6 py-6">
          <p className="text-center text-gray-500 text-base">
            {getTranslation(language, 'copyright')} {getTranslation(language, 'companyName')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;